<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Row>
        <ColumnUi md="9">
          <template v-if="newsLetter">
            <Title tag="h1" v-if="newsLetter">Boletín</Title>
            <Title tag="h2" theme="primary" v-if="newsLetter">
              {{ newsLetter.title }}
            </Title>
          </template>
          <Title tag="h1" v-else>Boletines Atmósfera - Hidrósfera</Title>
          <Content v-if="content" :content="content" />
          <div v-else>
            <p>
              Los eventos meteorológicos e hidroclimaticos, llamados “eventos
              extremos” son aquellos que ocurren muy rara vez, pero cuando lo
              hacen constituirse como un peligro importante para la sociedad. En
              el Perú, debido a su compleja geografía, existen zonas expuestas a
              estos peligros, siendo por lo general, las áreas urbanas quienes
              presentan una alta vulnerabilidad. Por ejemplo, el fenómeno El
              Niño genera lluvias extremas en la costa norte y sequías en los
              andes centrales y el sur. Por otro lado, la sierra, donde hay
              población y se desarrollan actividades agrícolas por encima de los
              4000 msnm de altura, esta expuesta a bajas temperaturas y heladas
              durante la temporada seca, alta insolación durante el día y a
              lluvias intensas durante la temporada húmeda. Todos estos peligros
              causan huaicos, deslizamientos y avalanchas, y a la vez pueden
              ocurrir sequías y veranillos. La Amazonía, por su parte, también
              alterna periodos de sequías e inundaciones, así como friajes con
              graves consecuencias para la población y el ecosistema.
            </p>
            <p>
              El estudio de estos eventos extremos, han sido parte de
              importantes proyectos de investigación desarrollados en el IGP
              para comprender su origen y desarrollo, así como los niveles de
              exposición de la población, la agricultura y obras de ingeniería.
              Asimismo, estos proyectos han permitido contar con instrumentación
              especializada para su monitoreo y ello, ha permitido generar
              información continua en el tiempo que nos permite hacer su
              seguimiento y la identificación de anomalías en sus procesos que
              puedan se utilizadas para dar alertas y así, reducir el riesgo al
              cual nos encontramos expuestos. Con esta finalidad, se ha iniciado
              la publicación de los Boletines
              <router-link to="/boletines/incendios-forestales">
                “Indicadores de la vegetación andina amazónica para la
                prevención de incendios forestales”
              </router-link>
              y
              <router-link to="/boletines/valle-mantaro">
                “Eventos fríos y lluviosos en el valle de Mantaro”
              </router-link>
              , esperando que sea de interés de autoridades y población en
              general.
            </p>
          </div>
        </ColumnUi>
        <!--
        <ColumnUi md="3">
          <h3>En esta sección</h3>
          <List marked>
            <li v-for="(subp, index) in subprograms" :key="index">
              <router-link
                v-if="!newsLetter || newsLetter.slug != subp.slug"
                :to="`/boletines/${subp.slug}`"
              >
                {{ subp.title }}
              </router-link>
              <span v-else>
                {{ subp.title }}
              </span>
            </li>
          </List>
        </ColumnUi>
        -->
        <ColumnUi md="3">
          <div>
            <Title tag="h3" theme="normal"><b>BOLETINES</b></Title>
            <List marked>
              <li v-for="(news, index) in newsLetters" :key="index">
                <router-link
                  v-if="
                    (!newsLetter && news.slug != '') ||
                      (news.slug != '' && newsLetter.slug != news.slug)
                  "
                  :to="`/boletines/${news.slug}`"
                >
                  {{ news.title }}
                </router-link>
                <a
                  v-else-if="news.slug != ''"
                  style="text-decoration: underline; pointer-events: none;"
                >
                  {{ news.title }}
                </a>
                <span v-else class="is-muted">
                  {{ news.title }}
                </span>
              </li>
            </List>
          </div>
          <div v-if="newsLetter">
            <template
              v-for="(list, index) in newsLetter.bulletins"
              :key="index"
            >
              <ItemList :list="list.data" :title="list.year.toString()" />
            </template>
            <!--
            <div
              v-for="(list, index) in newsLetter.bulletins"
              :key="index"
              class="item-list"
            >
              <h3>{{ list.year }}</h3>
              <List>
                <li v-for="(data, index) in list.data" :key="index">
                  <a target="_blank" :href="`${data.path}`">
                    {{ data.title }}
                  </a>
                </li>
              </List>
            </div>
            -->
          </div>
        </ColumnUi>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getNewsletters } from "@/newsletter.js";
import Container from "@/components/ui/objects/Container";
import List from "@/components/ui/objects/List.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";
import Trail from "@/components/common/Trail.vue";
import Title from "@/components/ui/atoms/Title.vue";
import { useRoute } from "vue-router";
import Content from "@/components/common/Content.vue";
import ItemList from "@/components/common/ItemList.vue";

export default {
  components: {
    Trail,
    Container,
    Row,
    ColumnUi,
    List,
    Title,
    Content,
    ItemList
  },
  setup() {
    const newsLetters = getNewsletters(process.env.VUE_APP_PREFIX);
    const route = useRoute().params.newsletter;
    const newsLetter = newsLetters.find(
      newsletter => route != "" && newsletter.slug == route
    );
    const content = newsLetter && newsLetter.content;

    return {
      newsLetter,
      content,
      newsLetters
    };
  }
};
</script>
